import { createRoutine } from 'redux-saga-routines'

export const changePass = createRoutine('CHANGE_PASSWORD');
export const switchNotificationsReceive = createRoutine('SWITCH_NOTIFICATIONS');